import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    padding: 0px 10%;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

export default Container;